module.exports = __webpack_public_path__ + "static/media/emoji-meh-svgrepo-com.5ae42681.svg";